// 状态 1已完成 0未完成 3审核中 4未通过
// http://autotest.hunliji.com/#/home/project/api/edit?projectId=-701335349&apiId=207473&moduleid=3675
export const TASK_TODO = 0
export const TASK_FINISH = 1
export const TASK_VERIFY = 3
export const TASK_UNPASS = 4

export const PLAN_NOT_START = -1
export const PLAN_IS_OVER = 0
